import { gql } from '@apollo/client';

import SERVICE_TYPES_FRAGMENT from '../services';

const USER_IN_TRANSACTION = gql`
  ${SERVICE_TYPES_FRAGMENT}
  fragment UserInTransaction on User {
    firstName
    lastName
    id
    company {
      id
      serviceTypes {
        ...ServiceTypesFragment
      }
    }
  }
`;
export default USER_IN_TRANSACTION;
